export function DispatchBanner() {
  return (
    <div className="bg-salt-dark text-white py-2 px-4 text-center flex items-center justify-center gap-3 fixed bottom-[74px] md:bottom-0 left-0 right-0 z-[60]">
      <div className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
      </div>
      <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-green-400">
        Dispatch Status: ACTIVE
      </span>
      <span className="text-[10px] md:text-xs font-medium text-gray-300 hidden sm:inline">
        - Tonnage Available in OH, IN, KY, TN
      </span>
    </div>
  );
}

import { Link } from "react-router-dom";
import { NavLink } from "./NavLink";
import { Menu, ChevronDown, ChevronRight } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useState } from "react";
import { kujoProducts } from "@/lib/kujoProducts";

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link className="flex items-center group" to="/">
              <img
                src="https://vibe.filesafe.space/1774883178162043817/attachments/143fc069-80c1-443b-8bda-33476d8a66fb.png"
                alt="911 Sourcing Logo"
                className="h-14 w-auto"
              />
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-6">
            <NavLink
              className="text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900"
              activeClassName="!text-gray-900 !border-gray-900"
              to="/"
            >
              Home
            </NavLink>
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center gap-1 text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900 data-[state=open]:text-gray-900 outline-none">
                Our Offerings <ChevronDown className="w-3 h-3" />
              </DropdownMenuTrigger>
              <DropdownMenuContent
                align="start"
                className="w-48 bg-white z-[60]"
              >
                <DropdownMenuItem asChild>
                  <Link
                    to="/salt-supply"
                    className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                  >
                    Salt Supply
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link
                    to="/plant-finder"
                    className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                  >
                    Plant Finder
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link
                    to="/ai-receptionist"
                    className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                  >
                    AI Receptionist
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link
                    to="/mini-weather-station"
                    className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                  >
                    Weather Station
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuSub>
                  <DropdownMenuSubTrigger className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2">
                    Kujo Yardwear
                  </DropdownMenuSubTrigger>
                  <DropdownMenuSubContent className="w-56 bg-white max-h-[70vh] overflow-y-auto z-[70]">
                    <DropdownMenuItem asChild>
                      <Link
                        to="/kujo-apparel"
                        className="w-full text-xs font-black uppercase tracking-widest text-plant-green cursor-pointer py-2"
                      >
                        All Products
                      </Link>
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    {kujoProducts.map((product) => (
                      <DropdownMenuItem key={product.slug} asChild>
                        <Link
                          to={`/kujo-apparel/${product.slug}`}
                          className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                        >
                          {product.name}
                        </Link>
                      </DropdownMenuItem>
                    ))}
                  </DropdownMenuSubContent>
                </DropdownMenuSub>
                <DropdownMenuItem asChild>
                  <a
                    href="https://store.911sourcing.com/products-list/collections/courses"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                  >
                    Courses
                  </a>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center gap-1 text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900 data-[state=open]:text-gray-900 outline-none">
                Resources <ChevronDown className="w-3 h-3" />
              </DropdownMenuTrigger>
              <DropdownMenuContent
                align="start"
                className="w-48 bg-white z-[60]"
              >
                <DropdownMenuItem asChild>
                  <Link
                    to="/plant-calculator"
                    className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                  >
                    Plant Calculator
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link
                    to="/salt-calculator"
                    className="w-full text-xs font-bold uppercase tracking-widest text-gray-600 hover:text-gray-900 cursor-pointer py-2"
                  >
                    Salt Calculator
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <NavLink
              className="text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900"
              activeClassName="!text-gray-900 !border-gray-900"
              to="/how-it-works"
            >
              How It Works
            </NavLink>
            <NavLink
              className="text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900"
              activeClassName="!text-gray-900 !border-gray-900"
              to="/service-areas"
            >
              Service Areas
            </NavLink>
            <NavLink
              className="text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900"
              activeClassName="!text-gray-900 !border-gray-900"
              to="/blog"
            >
              Blog
            </NavLink>
            <a
              href="https://store.911sourcing.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900"
            >
              Store
            </a>
            <NavLink
              className="text-[11px] font-extrabold uppercase tracking-widest transition-all pb-1 text-gray-500 border-b-2 border-transparent hover:text-gray-900"
              activeClassName="!text-gray-900 !border-gray-900"
              to="/contact"
            >
              Contact
            </NavLink>
            <Link
              className="px-6 py-3 text-[11px] font-black uppercase tracking-widest bg-salt-dark text-white transition-all hover:bg-gray-800"
              to="/contact"
            >
              Request Sourcing
            </Link>
          </div>

          {/* Mobile Nav Toggle */}
          <div className="flex md:hidden items-center">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <button
                  className="p-2 -mr-2 text-salt-dark hover:text-salt-orange transition-colors"
                  aria-label="Open menu"
                >
                  <Menu className="w-6 h-6" />
                </button>
              </SheetTrigger>
              <SheetContent
                side="right"
                className="w-[85vw] sm:w-[350px] bg-white pt-16 flex flex-col h-full"
              >
                <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
                <SheetDescription className="sr-only">
                  Mobile navigation links
                </SheetDescription>

                <div className="flex flex-col space-y-6 overflow-y-auto pb-20">
                  <NavLink
                    onClick={() => setIsOpen(false)}
                    className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                    activeClassName="text-salt-orange"
                    to="/"
                  >
                    Home
                  </NavLink>
                  <div className="flex flex-col space-y-4 pt-2 pb-2">
                    <span className="text-sm font-black uppercase tracking-widest text-gray-400">
                      Our Offerings
                    </span>
                    <div className="flex flex-col space-y-4 pl-4 border-l-2 border-gray-100">
                      <NavLink
                        onClick={() => setIsOpen(false)}
                        className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                        activeClassName="text-salt-orange"
                        to="/salt-supply"
                      >
                        Salt Supply
                      </NavLink>
                      <NavLink
                        onClick={() => setIsOpen(false)}
                        className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                        activeClassName="text-salt-orange"
                        to="/plant-finder"
                      >
                        Plant Finder
                      </NavLink>
                      <NavLink
                        onClick={() => setIsOpen(false)}
                        className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                        activeClassName="text-salt-orange"
                        to="/ai-receptionist"
                      >
                        AI Receptionist
                      </NavLink>
                      <NavLink
                        onClick={() => setIsOpen(false)}
                        className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                        activeClassName="text-salt-orange"
                        to="/mini-weather-station"
                      >
                        Weather Station
                      </NavLink>
                      <NavLink
                        onClick={() => setIsOpen(false)}
                        className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                        activeClassName="text-salt-orange"
                        to="/kujo-apparel"
                      >
                        Kujo Yardwear
                      </NavLink>
                      <div className="flex flex-col space-y-3 pl-8 border-l-2 border-gray-50">
                        {kujoProducts.map((product) => (
                          <NavLink
                            key={product.slug}
                            onClick={() => setIsOpen(false)}
                            className="text-[11px] font-bold uppercase tracking-wider text-gray-500 hover:text-salt-orange transition-colors"
                            activeClassName="text-salt-orange"
                            to={`/kujo-apparel/${product.slug}`}
                          >
                            {product.name}
                          </NavLink>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col space-y-4 pb-2">
                    <span className="text-sm font-black uppercase tracking-widest text-gray-400">
                      Resources
                    </span>
                    <div className="flex flex-col space-y-4 pl-4 border-l-2 border-gray-100">
                      <NavLink
                        onClick={() => setIsOpen(false)}
                        className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                        activeClassName="text-salt-orange"
                        to="/plant-calculator"
                      >
                        Plant Calculator
                      </NavLink>
                      <NavLink
                        onClick={() => setIsOpen(false)}
                        className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                        activeClassName="text-salt-orange"
                        to="/salt-calculator"
                      >
                        Salt Calculator
                      </NavLink>
                    </div>
                  </div>

                  <NavLink
                    onClick={() => setIsOpen(false)}
                    className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                    activeClassName="text-salt-orange"
                    to="/how-it-works"
                  >
                    How It Works
                  </NavLink>
                  <NavLink
                    onClick={() => setIsOpen(false)}
                    className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                    activeClassName="text-salt-orange"
                    to="/service-areas"
                  >
                    Service Areas
                  </NavLink>
                  <NavLink
                    onClick={() => setIsOpen(false)}
                    className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                    activeClassName="text-salt-orange"
                    to="/blog"
                  >
                    Blog
                  </NavLink>
                  <a
                    onClick={() => setIsOpen(false)}
                    className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors block"
                    href="https://store.911sourcing.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Store
                  </a>
                  <NavLink
                    onClick={() => setIsOpen(false)}
                    className="text-sm font-black uppercase tracking-widest text-salt-dark hover:text-salt-orange transition-colors"
                    activeClassName="text-salt-orange"
                    to="/contact"
                  >
                    Contact
                  </NavLink>

                  <div className="pt-4 mt-auto">
                    <Link
                      onClick={() => setIsOpen(false)}
                      className="block w-full px-6 py-4 text-xs text-center font-black uppercase tracking-widest bg-salt-dark text-white transition-all hover:bg-gray-800 rounded"
                      to="/contact"
                    >
                      Request Sourcing
                    </Link>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
}
